import React , { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { connect, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { useLocation, } from 'react-router-dom'; 
import AddPlan from './components/AddPlan';
import { planLisitingRequest ,deletePlan} from '../plans/redux/planDispatcher';
import { getCategoryLisiting} from '../category/redux/categoryDispatcher';


function PlansListingTable({planListing}) {

  console.log("plan listing-----",planListing.planDetail);
  const paginationModel = { page: 0, pageSize: 10 };

  const dispatch = useDispatch();
  const location = useLocation();



  const [categories, setCategories] = useState([]);


  const plansListingHeading =[

    {
      field: "id", headerName: "NO", width: 40,
     renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },

    { 
      field: "planName", headerName: "Plan Name", width: 300 ,
      // renderCell: (params) => params.value, 
    },

    { 
      field: "price", headerName: "Plan Price", width: 150 ,
      // renderCell: (params) => params.value, 
    },

    {
      field: "daysOfListing", headerName: "Days", width: 100 ,
  
    },
    {
      field: "bump", headerName: "Bump", width: 100 ,
  
    },

    {
      field: "numberOfPhotos", headerName: "Photos", width: 100 ,
  
    },

    
   {
  field: "recommended",
  headerName: "Recommended",
  width: 120,
  renderCell: (params) => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h6>{params.value === 1 ? "Yes" : "No"}</h6>
      </div>
    );
  },
},


    {
      field: "priorityPlacement", headerName: "Priority", width: 100 ,
  
    },



    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params,row) => {
        console.log("veiw is called", params, row);


        return (
          <div style={{ display: "flex", flexDirection: "row", gap: "4px",alignItems: "center",
            height: "100%" }}>
             <AddPlan
            buttonLabel="Edit"
            editMode={true}
            planData={params.row}
            categories={categories}

          />


             <button
            onClick={() => handleDelete(params.row)}
            style={{
              backgroundColor: "#F44336",
              color: "white",
              border: "none",
              cursor: "pointer",
              borderRadius: "4px",
              fontSize: "10px",
              width: "30%",
              height: "24px",  // Increased height
              padding: "2px 5px", // Added padding
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Delete
           </button>
         
      
        </div>
        
        );
      },    },


  ];


  const handleDelete = (row) => {
    console.log("Deleting Plan ID:", row);
    Swal.fire({
      title: ``,
      html:
        "" +
        "Are you sure?" +
        "<br>" +
        `You want to Delete plan "${row.planName}"`,
      showCancelButton: true,
      cancelButtonText: "Cancel",
      confirmButtonText: `Yes, Delete`,
      showCloseButton: true,
      cancelButtonColor: "gray",
      confirmButtonColor: "#4f83df",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        dispatch(deletePlan(row.id,));
      }
    });
  
    // Add your delete logic here
  };

  const fetchedRef = React.useRef(false);

  React.useEffect(() => {
    if (!fetchedRef.current) {
      fetchedRef.current = true; // mark as fetched
  
      const fetchCategories = async () => {
        try {
          const result = await dispatch(getCategoryLisiting());
          setCategories(result);
          console.log("Fetched categories:", result);
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      };
  
      fetchCategories();
    }
  
    dispatch(planLisitingRequest());
  }, [dispatch, location.pathname]);
  
  return (
    
    <Paper sx={{ height: "95%", width: '100%' }}>


<div style={{padding:"10px", justifyItems:"end"}}> 
<AddPlan  buttonLabel={"Add Plans"}
            categories={categories}
/>
  </div>
  

  

   
         
 
    


      <DataGrid
        rows={planListing.planListing || []}
        columns={plansListingHeading || []}
        initialState={{ pagination: { paginationModel } }}
        pageSizeOptions={[10, 25]}
        rowHeight={80}
        loading = {planListing.loading}
        checkboxSelection={false}
        sx={{ border: 0 }}
        

      />
    </Paper>
  );
}




//Getting the state from the store
const mapStateToProps = (state) => {
  console.log(
    "PERMISSSION:::::::::"
  ,state.planReducer);
  return {
    planListing: state.planReducer, // Add optional chaining
  };
};



//passing the plan Data  in fetchPlans function and also dispatch method
const mapDispatchToProps = (dispatch) => {
  return {
    planLisitingRequest: () => dispatch({"type":"GET_PLAN_REQUEST"}), // Corrected function name
  };
};




//Connecting the component to our store
export default connect(mapStateToProps, mapDispatchToProps)(PlansListingTable);
